import React, { useMemo } from 'react';
import * as THREE from 'three';
import { getBoxGeometry } from '../../../../utils/threeResourcePool';

export type AmhsPooledBoxProps = {
  size: [number, number, number];
  material: THREE.Material;
  position?: [number, number, number];
  rotation?: [number, number, number];
  castShadow?: boolean;
  receiveShadow?: boolean;
};

/** Box mesh backed by the global geometry cache — no per-mount BufferGeometry alloc. */
export const AmhsPooledBox: React.FC<AmhsPooledBoxProps> = React.memo(
  ({
    size,
    material,
    position = [0, 0, 0] as [number, number, number],
    rotation = [0, 0, 0] as [number, number, number],
    castShadow = false,
    receiveShadow = false,
  }) => {
    const geometry = useMemo(
      () => getBoxGeometry(size[0], size[1], size[2]),
      [size[0], size[1], size[2]]
    );

    return (
      <mesh
        position={position}
        rotation={rotation}
        geometry={geometry}
        material={material}
        castShadow={castShadow}
        receiveShadow={receiveShadow}
      />
    );
  }
);

AmhsPooledBox.displayName = 'AmhsPooledBox';

export default AmhsPooledBox;
